module.exports = __webpack_public_path__ + "img/6.bf907573.jpg";